import { NgModule } from '@angular/core';
import { SvgIconsModule } from '@ngneat/svg-icon';
import { AccordionModule } from './lib/accordion/accordion.module';
import { AccordionModule2 } from './lib/accordion2/accordion2.module';
import { AdminTableModule } from './lib/admin-table/admin-table.module';
import { AlertModule } from './lib/alert/alert.module';
import { ButtonGroupModule } from './lib/button/button-group/button-group.module';
import { ChartModule } from './lib/chart/chart.module';
import { CheckboxModule } from './lib/checkbox/checkbox.module';
import { DatepickerModule } from './lib/datepicker/datepicker.module';
import { DirectivesModule } from './lib/directives/directives.module';
import { DrawerModule } from './lib/drawer/drawer.module';
import { DropdownModule } from './lib/dropdown/dropdown.module';
import { InfoBoxModule } from './lib/info-box/info-box.module';
import { LoadingModule } from './lib/loading/loading.module';
import { ModalModule } from './lib/modal/modal.module';
import { NotificationModule } from './lib/notification/notification.module';
import { PipesModule } from './lib/pipes/pipes.module';
import { RadioButtonModule } from './lib/radio-button/radio-button.module';
import { RangeSliderModule } from './lib/range-slider/range-slider.module';
import { TableModule } from './lib/table/table.module';
import { TabsModule } from './lib/tabs/tabs.module';
import { TagModule } from './lib/tag/tag.module';
import { TextInputModule } from './lib/text-input/text-input.module';
import { ToggleSwitchModule } from './lib/toggle-switch/toggle-switch.module';
import { TooltipModule } from './lib/tooltip/tooltip.module';
import { WizardModule } from './lib/wizard/wizard.module';
import icons from './svg';
import { BreadCrumbsModule } from './lib/breadcrumbs/breadcrumbs.module';

@NgModule({
  imports: [
    DirectivesModule,
    ButtonGroupModule,
    TextInputModule,
    NotificationModule,
    TooltipModule,
    RadioButtonModule,
    ToggleSwitchModule,
    AccordionModule,
    RadioButtonModule,
    CheckboxModule,
    TagModule,
    RangeSliderModule,
    ChartModule,
    TableModule,
    DropdownModule,
    InfoBoxModule,
    ModalModule,
    AlertModule,
    AccordionModule2,
    TabsModule,
    AdminTableModule,
    DrawerModule,
    WizardModule,
    DatepickerModule,
    LoadingModule,
    PipesModule,
    BreadCrumbsModule,
    SvgIconsModule.forRoot({
      sizes: {
        sm: '0.8rem',
        md: '1rem',
        lg: '1.2rem',
        xl: '1.4rem'
      },
      defaultSize: 'xl',
      icons: icons
    })
  ],
  exports: [
    DirectivesModule,
    ButtonGroupModule,
    TextInputModule,
    ToggleSwitchModule,
    AccordionModule,
    RadioButtonModule,
    CheckboxModule,
    NotificationModule,
    NotificationModule,
    RadioButtonModule,
    ToggleSwitchModule,
    AccordionModule,
    RadioButtonModule,
    CheckboxModule,
    TagModule,
    CheckboxModule,
    TooltipModule,
    RangeSliderModule,
    ChartModule,
    TableModule,
    DropdownModule,
    InfoBoxModule,
    ModalModule,
    AlertModule,
    AccordionModule2,
    TabsModule,
    AdminTableModule,
    DrawerModule,
    WizardModule,
    DatepickerModule,
    LoadingModule,
    PipesModule,
    BreadCrumbsModule,
    SvgIconsModule,
  ],
  declarations: [
  ]
})
export class MarketProDesignModule {
}

